export class ClientMetrics {
  id: string;
  average_net_tuition : number;
  cost_per_credit_hour : number;
  average_credits_per_student : number;
  average_student_head_count : number;
  typical_enrollment_rate : number;
  typical_melt_rate : number;
  typical_persistence_rates : number;
  typical_stopout_recovery_rate : number;
  
  constructor(data?: Partial<ClientMetrics>) {
    this.id = data?.id ?? "";
    this.average_net_tuition = data?.average_net_tuition ?? 0;
    this.cost_per_credit_hour = data?.cost_per_credit_hour ?? 0;
    this.average_credits_per_student = data?.average_credits_per_student ?? 0;
    this.average_student_head_count = data?.average_student_head_count ?? 0;
    this.typical_enrollment_rate = data?.typical_enrollment_rate ?? 0;
    this.typical_melt_rate = data?.typical_melt_rate ?? 0;
    this.typical_persistence_rates = data?.typical_persistence_rates ?? 0;
    this.typical_stopout_recovery_rate = data?.typical_stopout_recovery_rate ?? 0;
  }
}
